import { createReducer, on } from '@ngrx/store';
import * as WindowActions from './window.actions';
import { initialState } from './window.state';

export const windowReducer = createReducer(
  initialState,
  
  // Window actions are side effects only, no state changes needed
  on(WindowActions.openWindow, state => state),
  on(WindowActions.closeWindow, state => state),
  on(WindowActions.closeWindowAndOpenNext, state => state)
);
